/* unplugin-vue-components disabled */import { render } from "./style4.vue?vue&type=template&id=13b8babc&scoped=true"
import script from "./style4.vue?vue&type=script&lang=js"
export * from "./style4.vue?vue&type=script&lang=js"

import "./style4.vue?vue&type=style&index=0&id=13b8babc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b8babc"]])

export default __exports__